export default __webpack_public_path__ + "fonts/9f17095c73207c3034552ddcc84fe29d.woff2";